import React from 'react';
import PropTypes from 'prop-types';
import {BoxIcon} from '../../Icons';
import {BoxTooltip} from './BoxTooltip';
import className from './style.module.scss';
import {Image} from '@learningblocks/shared-components';

export function Box(props) {
  const [hover, setHover] = React.useState(false);

  const toggleHover = (value) => () => setHover(value);

  return (
    <div
      tabIndex='0'
      className={className.box}
      onMouseEnter={toggleHover(true)}
      onMouseLeave={toggleHover(false)}>
      <BoxTooltip selected={hover}  buttonList={ props.buttonList }/>
      <Image src={BoxIcon} alt='box-icon' />
    </div>
  );
}

Box.propTypes = {};

Box.defaultProps = {};
